export default "__VITE_ASSET__Dq$9xjwl__"